import RedeemActivityContent from "./RedeemActivityContent";

export default RedeemActivityContent;